/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import cx from 'classnames';
import { Icon, Checkbox } from 'semantic-ui-react';

class BookmarkItemType2 extends Component {
  constructor(props) {
    super(props);
    this.handleRemoveRecentList = this.handleRemoveRecentList.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
  }

  componentDidMount() {}

  handleCheckChange(e, { value }) {
    const { handleTableToggle } = this.props;
    handleTableToggle(value);
  }

  handleTableToggle = (e) => {
    const { handleTableToggle, item } = this.props;
    if (e.target.classList.length !== 0) {
      let i = 0;
      for (i; i < e.target.classList.length; i++) {
        if (e.target.classList[i].indexOf('icon') > -1) {
          return null;
        }
      }
    }
    handleTableToggle(item.id);
  };

  handleChangeView = (e) => {
    const { handleChangeView, item } = this.props;
    const {
      target_id, view_point, extra_data, name
    } = item;
    const obj = {
      targetObject: 'report',
      targetId: target_id,
      viewPoint: view_point,
      name,
      projectName: extra_data.project || null,
      type: e.currentTarget.dataset.id,
    };

    handleChangeView(obj);
  };

  handleRemoveRecentList = () => {
    const { handleRemoveRecentList, item } = this.props;
    const { name, id } = item;
    const obj = {
      name,
      id,
    };
    handleRemoveRecentList(obj);
  };

  converToString() {
    const { item } = this.props;
    const firstL = item.view_point.slice(0, 1).toUpperCase();
    const rest = item.view_point.slice(1).toLowerCase();
    return firstL.concat(rest);
  }

  render() {
    const { selectedRecentList, item } = this.props;
    return (
      <div className="my_bookmarks_item">
        <table
          className={cx('my_bookmarks_item_table', {
            selected: selectedRecentList.indexOf(item.id) >= 0,
          })}
          onClick={this.handleTableToggle}
          onKeyUp={this.handleTableToggle}
        >
          <colgroup>
            <col style={{ width: '4.3%', maxWidth: '52px' }} />
            <col style={{ width: '29%', maxWidth: '350px' }} />
            <col style={{ width: '66%', maxWidth: '800px' }} />
          </colgroup>
          <tbody>
            <tr>
              <td className="left_td">
                <a className="checkbox_button">
                  <Checkbox
                    value={item.id}
                    checked={selectedRecentList.indexOf(item.id) >= 0}
                    onChange={this.handleCheckChange}
                  />
                </a>
              </td>
              <td style={{ verticalAlign: 'middle', textAlign: 'left' }}>
                <div className="info">
                  <a className="name">
                    <span data-id="current" onClick={this.handleChangeView} onKeyUp={this.handleChangeView}>
                      {item.name}
                    </span>
                  </a>
                  <p className="project_name">{`${item.extra_data.project} / ${item.extra_data.project_version}`}</p>
                </div>
              </td>
              <td className="right_td">
                <span className="label active">{this.converToString()}</span>
                <span className="date">{item.updated_at}</span>
                <div className="button_wrap">
                  <a className="button" data-id="window" onClick={this.handleChangeView} onKeyUp={this.handleChangeView}>
                    <Icon
                      name="external alternate"
                      color="grey"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                    />
                  </a>
                  <a className="button delete_button" onClick={this.handleRemoveRecentList} onKeyUp={this.handleRemoveRecentList}>
                    <Icon
                      name="cancel"
                      style={{ fontSize: '15px', color: '#ff3a6c', cursor: 'pointer' }}
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
export default BookmarkItemType2;
